import { useQuery, useQueryClient } from '@tanstack/react-query';
import { environment } from '@/constants/environment';
import { HttpService, UserService } from '@/services';
import type { Session } from '@/types';

export function useSession() {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ['session'],
    queryFn: async (): Promise<Session> => {
      let token: string | null | undefined;

      try {
        if (environment === 'development' && process.env.NEXT_PUBLIC_AUTH_TOKEN) {
          token = process.env.NEXT_PUBLIC_AUTH_TOKEN;
        } else {
          token = await UserService.getAccessToken();
        }
        if (token) HttpService.setAuthorizationHeader(token);
      } catch {
        HttpService.unsetAuthorizationHeader();
        queryClient.setQueryData<Session>(['session'], undefined);
        queryClient.setQueryData(['userCourseStatus'], undefined);
      }

      return {
        token,
      };
    },
    staleTime: 10 * 60 * 1000, // 10min
  });
}
